export default __webpack_public_path__ + "static/media/BTB_solution.c70131d6.svg";